import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-logout-modal',
    template: `
    <div class="modal-content">
        <div class="card-header bg-primary">
            <div class="row">
                <div class="col-12 text-center">
                  <!-- <button type="button" class="btn btn-tool pt-3 float-right">
                    <i class="fas fa-times"></i>
                  </button> -->
                  Log Out
                </div>
            </div>
        </div>
        <div class="card-body">
          You will be log out due to inactivity in <b>{{_timer}}</b> second(s). Click on continue to stay signed in. Otherwise, you will logged out automatically
        </div>
        <div class="modal-footer text-right">
          <button (click)="onLogout()" class="btn btn-danger mr-2">Log Out</button>
          <button (click)="onContinue()" class="btn btn-primary">Continue</button>
        </div>
      </div>
    `,
    styles: ['']
})
export class LogoutModalComponent implements OnInit, OnDestroy {
    _timer: number = 60;
    private _logout_timer: number = 1000;
    private interval;
    public onClose : Subject<any>
    constructor(
      public bsModalRef: BsModalRef
    ) { }
    ngOnInit(): void {
      this.onClose = new Subject<any>();
      this.interval = setInterval((e)=>{
        console.log(this._timer);
        this._timer-=1;
        if (this._timer==0) {
          this.onLogout();
        }
      }, this._logout_timer)
    }

    onContinue() {
      this.onClose.next({logout: false});
      this.bsModalRef.hide();
    }
    onLogout() {
      this.onClose.next({logout: true});
      this.bsModalRef.hide();
    }

    ngOnDestroy(){
      clearInterval(this.interval);
    }
}
